import ChatbotIcon from '#/assets/svgs/ChatbotIcon.svg';

function LoadingDots({ chatBotImage, className = '' }) {
  return (
    <div className={`message receiver loading-dots ${className}`}>
      <div className="image">{chatBotImage ? <img src={chatBotImage} alt="Chatbot" /> : <ChatbotIcon />}</div>
      <p>
        <span className="dots">
          <span className="dot" />
          <span className="dot" />
          <span className="dot" />
        </span>
      </p>
    </div>
  );
}

export default LoadingDots;
